import getInstallmentType from "./resources/getInstallmentType";

export const InstallmentTypeCell = ({ original }) => {
  const installmentType = getInstallmentType(original);
  return <span>{installmentType}</span>;
};
